import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogAddScoreComponent } from "./dialog-add-score.component";
import { SharedModules } from "src/app/shared.modules";
import { FormsModule } from "@angular/forms";
import { DialogAddTagComponent } from "../dialog-add-tag/dialog-add-tag.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { CategoriesAndTagsDisplayComponent } from "../categories-and-tags-display/categories-and-tags-display.component";
import { CustomSliderComponent } from "../custom-slider/custom-slider.component";
import { DialogDefaultModalComponent } from "../dialog-default-modal/dialog-default-modal.component";
import { WavySectionModule } from "../wavy-section/wavy-section.module";

@NgModule({
  declarations: [DialogAddScoreComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModules,
    DialogAddTagComponent,
    AngularSvgIconModule,
    CategoriesAndTagsDisplayComponent,
    CustomSliderComponent,
    DialogDefaultModalComponent,
    WavySectionModule,
  ],
})
export class DialogAddScoreModule {}
